<template>
  <div>
    <v-list v-for="(item, id) in sekolah" :key="id" class="pb-0">
      <div :key="id">
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-hospital-building</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="blue--text">
                      {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                    </div>
                    <div class="black--text">
                      <b>NPSN : </b>
                      {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item-title>
                      <v-label color="caption"><small>Alamat Sekolah</small></v-label>
                    </v-list-item-title>
                    <div class="link black--text body-2">
                      <div>{{ $getDeepObj(item, 'sekolah.data.alamat') || '-' }}</div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item class="px-0 mt-3">
                  <v-list-item-content class="py-0">
                    <div>
                      <v-chip
                        :color="
                          $getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data.0.is_lengkap_individu')
                            ? 'success'
                            : '#ff8425'
                        "
                        dark
                        small
                      >
                        {{
                          $getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data.0.is_lengkap_individu')
                            ? 'Sudah Lengkap'
                            : 'Belum Lengkap'
                        }}
                      </v-chip>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item class="px-0 mt-3">
                  <v-list-item-content class="py-0">
                    <div v-if="$getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data.0.is_lengkap_individu')">
                      <v-btn color="secondary" class="white--text" small @click="onKuisioner(item, item.grup)">
                        <v-icon left dark>
                          mdi-pencil
                        </v-icon>
                        Ubah Laporan
                      </v-btn>
                    </div>
                    <div v-else>
                      <v-btn color="secondary" class="white--text" small @click="onKuisioner(item, item.grup)">
                        <v-icon left dark>
                          mdi-pencil
                        </v-icon>
                        Lengkapi
                      </v-btn>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="id + 1 < sekolah.length" />
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'DetailIndividu',
  props: {
    sekolah: {
      type: Array,
      default: () => [],
    },
    kPertemuan: {
      type: Number,
      required: true,
    },
  },
  methods: {
    onKuisioner(item, grup) {
      const options = {
        form: 'FormIndividu',
        title: 'Laporan Pendampingan Individu',
      };

      this.$emit('onKuisioner', { data: item, grup, options });
    },
  },
};
</script>

<style scoped></style>
